import axios from "axios";
import { BASE_URL } from "../../variables";

export const getAllSH3Emails = async ({ userEmailid, userRole, divisionCode, salesGroupCode }) => {
    try {
        let url = "";
        let whereClause = "";

        // WHERE clause is fixed based on logged-in user's role
        if (userRole === "SH7") {
            whereClause = `SH7_Email__c = '${userEmailid}'`;
        } else if (userRole === "SH5" || userRole === "SH6") {
            whereClause = `SH5_Email__c = '${userEmailid}'`;
        } else if (userRole === "TMM") {
            whereClause = `Division_Code__c = '${divisionCode}' AND Sales_Group__c = '${salesGroupCode}' AND Updated_by_DW__c = '1'`;
        }

        // SELECT SH3_Email__c to get BM users
        url = `${BASE_URL}/services/data/v56.0/query?q=SELECT SH3_Email__c FROM Pidilite_Hierarchy__c WHERE ${whereClause} AND RecordType.Name = 'Sales Hierarchy' GROUP BY SH3_Email__c`;

        const response = await axios.get(url);

        if (response.status === 200) {
            return {
                success: true,
                data: response?.data,
            };
        } else {
            throw new Error("Something Went Wrong..!!");
        }
    } catch (err) {
        console.error("Error fetching SH3 Emails:", err);
        return {
            success: false,
            msg: "Something Went Wrong..!!",
        };
    }
};
